import React from "react";
import { TrendingUp, Activity } from "lucide-react";

/**
 * GodsEye Institutional Trading System Loading Screen
 * Clean, modern financial terminal aesthetic.
 */
export default function GodsEyeLoadingScreen({
  message = "Loading...",
  subtitle = "Trading System",
  fullScreen = true,
  size = "medium", // "small" | "medium" | "large"
}) {
  const isFullScreen = fullScreen;

  return (
    <div
      className={
        isFullScreen
          ? "fixed inset-0 z-50 flex items-center justify-center bg-[#0a0c10] select-none p-4"
          : "flex items-center justify-center w-full py-16 px-4 bg-[#14161f]/90 rounded-lg border border-gray-800 select-none"
      }
    >
      {/* Centered Financial Terminal Card */}
      <div className="flex flex-col items-center max-w-sm w-full bg-[#14161f] border border-gray-800/80 rounded-2xl p-8 shadow-2xl shadow-black/90">
        
        {/* Precision Financial Spinner with Activity Icon */}
        <div className="relative w-16 h-16 flex items-center justify-center mb-5">
          {/* Outer Track Ring */}
          <div className="absolute inset-0 rounded-full border-2 border-gray-800" />

          {/* Smooth Gradient Spinner Arc */}
          <div className="absolute inset-0 rounded-full border-2 border-transparent border-t-blue-500 border-r-cyan-400 animate-spin" />

          {/* Center Housing with Trending Icon */}
          <div className="w-10 h-10 rounded-xl bg-[#1a1d29] border border-gray-700/60 flex items-center justify-center shadow-inner">
            <TrendingUp className="w-5 h-5 text-blue-400 drop-shadow-[0_0_6px_rgba(59,130,246,0.5)]" />
          </div>
        </div>

        {/* Platform Brand Title */}
        <div className="flex items-center gap-2 mb-1">
          <h2 className="text-xl font-black tracking-[0.2em] text-white font-sans">
            GODS<span className="text-blue-400">EYE</span>
          </h2>
          <span className="w-1.5 h-1.5 rounded-full bg-emerald-400 animate-pulse" />
        </div>

        {/* Subtitle */}
        <p className="text-[10px] font-mono tracking-[0.2em] text-gray-500 uppercase mb-5">
          {subtitle}
        </p>

        {/* Minimal Precision Progress Bar */}
        <div className="w-48 h-1 bg-[#1a1d29] rounded-full overflow-hidden relative mb-3.5 border border-gray-800">
          <div className="absolute top-0 bottom-0 left-0 w-20 bg-gradient-to-r from-blue-600 via-blue-400 to-cyan-400 rounded-full animate-[progressSlide_1.6s_ease-in-out_infinite]" />
        </div>

        {/* Clean Status Message */}
        <p className="text-xs text-gray-400 font-medium text-center tracking-tight">
          {message}
        </p>
      </div>

      {/* Embedded CSS Keyframes */}
      <style>{`
        @keyframes progressSlide {
          0% {
            transform: translateX(-100%);
          }
          50% {
            transform: translateX(110%);
          }
          100% {
            transform: translateX(250%);
          }
        }
      `}</style>
    </div>
  );
}
